import * as React from "react";
import { connect, ActionCreator } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import styled from "styled-components";

import { openSigninModal } from "../../lib/auth";
import { RootState } from "../../state";
import { followCompanyWorker, unfollowCompanyWorker } from "../actions";
import { colors } from "../../common/utils/style";
import { CurrentUser } from "../../common/actions/Auth";
import { companyFollowingSelector } from "../selectors";
import Translate from "../../common/components/Translate";

interface OwnProps {
  className?: string;
  companyId: number;
}

interface MappedProps {
  following: boolean;
  currentUser: CurrentUser | null;
}

interface MappedActions {
  followCompanyWorker: ActionCreator<void>;
  unfollowCompanyWorker: ActionCreator<void>;
}

type Props = OwnProps & MappedProps & MappedActions;

class FollowButtonContainer extends React.Component<Props> {
  public render() {
    const { className, companyId, following } = this.props;
    return (
      <FollowButton className={className} onClick={this.handleClick(companyId)}>
        <Translate id={`company.${following ? "following" : "follow"}`} />
      </FollowButton>
    );
  }

  private handleClick = (companyId: number) => (event: React.MouseEvent<HTMLElement>) => {
    const { currentUser, following, followCompanyWorker, unfollowCompanyWorker } = this.props;
    if (!currentUser) {
      openSigninModal(event.nativeEvent);
      return;
    }
    if (following) {
      unfollowCompanyWorker(companyId);
    } else {
      followCompanyWorker(companyId);
    }
  };
}

const FollowButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  min-width: 90px;
  height: 26px;
  border-radius: 22px;
  border: solid 1px rgba(0, 0, 0, 0.8);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  font-size: 13px;
  &:hover {
    background-color: ${colors.lightgray1};
  }
`;

function mapStateToProps(state: RootState, props: OwnProps): MappedProps {
  const following = companyFollowingSelector(state, props);
  const currentUser = state.auth.currentUser;
  return {
    following,
    currentUser,
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      followCompanyWorker,
      unfollowCompanyWorker,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowButtonContainer);



// WEBPACK FOOTER //
// ./frontend/src/company_followings/components/FollowButtonContainer.tsx